module.exports = __webpack_public_path__ + "static/media/burren.b19c7251.png";